import { ReportListItem } from './adapters/types';

export const ReportList: ReportListItem[] = [
    {
        title: "帳戶",
        name: "customer",
        fields:[
            "total",
            "daily",
            "daily_total",
        ]
    },
    {
        title: "廣告活動",
        name: "campaign",
        fields:[
            "total",
            "daily",
        ]
    },
    {
        title: "廣告群組",
        name: "ad_group",
        fields:[
            "total",
            "daily",
        ]
    },
    {
        title: "廣告",
        name: "ad_group_ad",
        note: '數據池含 AI Max 活動時附固定註記：文字素材自動化產生之標題／說明不列入本表，標題欄位可能不完整',
        fields:[
            "total",
            "daily",
        ]
    },
    {
        title: "關鍵字",
        name: "keyword",
        note: '對應後台「總計：您的關鍵字」，已排除 AI Max 擴充比對',
        fields:[
            "total",
            "daily",
            "no_match-total",
            "no_match-daily",
            "search_term",
        ]
    },
    {
        title: "AI Max 擴充比對",
        name: "ai_max_broad_match",
        note: '總計對應後台「總計：AI Max 擴充比對」。隱私門檻未顯示的字詞列為「(未揭露搜尋字詞)」並掛關聯關鍵字；未勾選「搜尋」或範圍=排除 AI Max 時本分頁無資料',
        fields:[
            "total",
            "daily",
            "campaign",
            "campaign-daily",
        ]
    },
    {
        title: "AI Max 相符的到達網頁",
        name: "ai_max_landing_page",
        note: '總計對應後台「總計：與 AI Max 相符的到達網頁」。隱私門檻未顯示的字詞列為「(未揭露搜尋字詞)」，維度到廣告群組；未勾選「搜尋」或範圍=排除 AI Max 時本分頁無資料',
        fields:[
            "total",
            "daily",
            "campaign",
            "campaign-daily",
        ]
    },
    {
        title: "性別",
        name: "gender",
        fields:[
            "total",
            "daily",
            "customer",
            "customer-daily",
            "campaign",
            "campaign-daily",
            "ad_group",
            "ad_group-daily",
        ]
    },
    {
        title: "年齡層",
        name: "age_range",
        fields:[
            "total",
            "daily",
            "customer",
            "customer-daily",
            "campaign",
            "campaign-daily",
            "ad_group",
            "ad_group-daily",
        ]
    },
    {
        title: "裝置",
        name: "device",
        fields:[
            "total",
            "daily",
            "customer",
            "customer-daily",
            "campaign",
            "campaign-daily",
            "ad_group",
        ]
    },
    {
        title: "時段",
        name: "ad_schedule",
        fields:[
            "customer",
            "customer-daily",
            "campaign",
            "campaign-daily",
        ]
    },
    // {
    //     title: "廣告活動標籤",
    //     name: "campaign-label",
    //     fields:[
    //         "total",
    //         "daily",
    //     ]
    // },
    // {
    //     title: "廣告群組標籤",
    //     name: "ad_group-label",
    //     fields:[
    //         "total",
    //         "daily",
    //     ]
    // },
    {
        title: "廣告標籤",
        name: "label",
        fields:[
            "customer",
            "customer-daily",
            "campaign",
            "ad_group",
        ]
    },
    {
        title: "轉換動作", /* 未分別列與欄  */
        name: "conversion_action",
        fields:[
            "customer",
            "campaign",
            "ad_group",
            "keyword",
            // "ad_group_ad-label",
            // "ad_group_ad-keyword",
        ]
    },
    {
        title: "所有轉換動作", /* 未分別列與欄  */
        name: "all_conversion_action",
        fields:[
            "customer",
            "campaign",
            "ad_group",
            "keyword",
            // "ad_group_ad-label",
            // "ad_group_ad-keyword",
        ]
    },
    {
        title: "額外資訊", /* 未列於postman api中  */
        name: "asset",
        fields:[
            "total",
            "daily",
            "campaign",
            "campaign-daily",
        ]
    },
    {
        title: "目標對象",
        name: "audience",
        fields:[
            "customer",
            "customer-daily",
            "campaign",
            "campaign-daily",
            "ad_group",
            "ad_group-daily",
        ]
    },
    // {
    //     title: "主題",
    //     name: "Topic",
    //     fields:[
    //         "customer",
    //         "customer-daily",
    //         "campaign",
    //         "campaign-daily",
    //         "ad_group",
    //         "ad_group-daily",
    //     ]
    // },
    {
        title: "指定地區",
        name: "location",
        fields:[
            "customer",
            "campaign",
            "campaign-daily",
        ]
    },
    {
        title: "地理位置",
        name: "geographic",
        fields:[
            "county",
            "city",
            "region",
        ]
    },
    {
        title: "使用者地區",
        name: "user_location",
        fields:[
            "county",
            "city",
            "region",
        ]
    },
    {
        title: "素材資源群組",
        name: "asset_group",
        note: 'AI Max（搜尋）活動無素材資源群組：範圍為「僅 AI Max 活動」時本分頁無資料，附註記產出空表（停用邏輯列下一版本）',
        noteWhenAiMaxOnly: true,
        fields:[
            "total",
            "daily",
            "campaign",
            "campaign-daily",
        ]
    },
];